import React from 'react';
import { QuestionHeading, QuestionPreviewField } from './QuestionBlockShared';

function TextBlock({ block, position }) {
    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionPreviewField>
                <input
                    type={block.inputType || 'text'}
                    className="form-control form-control-sm"
                    placeholder={block.placeholder || 'Answer'}
                    disabled
                />
            </QuestionPreviewField>
        </div>
    );
}

export default TextBlock;
